/**
 * Gift Card Language Selector
 * Handles language-based variant selection and image updates for gift card products
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  function initGiftCardLanguage() {
    // Check for both possible language swatch class names (different translations)
    const languageSwatchContainer = document.querySelector('.js-swatch-Taal') ||
                                    document.querySelector('.js-swatch-Langue');

    if (!languageSwatchContainer) {
      return;
    }

    // Get data from the product page - support both data structure patterns
    const currentLocale = window.giftCardData?.currentLocale || window.giftcardCurrentLocale || '';
    const variants = window.giftCardData?.variants || window.giftcardVariants || [];

    if (!currentLocale || !variants.length) {
      console.warn('Gift card data not found');
      return;
    }

    const languageInputs = languageSwatchContainer.querySelectorAll('input[type="radio"]');

    /**
     * Update the gift card image based on the selected language
     * @param {string} language - The language code (e.g., 'en', 'nl', 'fr')
     */
    function updateImageForLanguage(language) {
      const localeVariant = variants.find(v => v.option2 === language);
      const giftCardImage = document.querySelector('.product-gallery__wrapper--giftcard img');

      if (localeVariant && localeVariant.featured_image && giftCardImage) {
        // Update image source with proper sizing
        giftCardImage.src = localeVariant.featured_image.src.replace(/(\.\w{3,4})$/, '_1000x$1');
        giftCardImage.alt = localeVariant.title || localeVariant.featured_image.alt;
        giftCardImage.setAttribute('data-variant-id', localeVariant.id);
      }
    }

    // Add change event listeners to radio buttons
    languageInputs.forEach(input => {
      // Select the input matching the current locale
      if (input.value === currentLocale) {
        input.checked = true;
      }

      // Listen for language changes
      input.addEventListener('change', function() {
        if (this.checked) {
          updateImageForLanguage(this.value);
        }
      });
    });

    // Perform initial image update on page load
    updateImageForLanguage(currentLocale);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftCardLanguage);
  } else {
    // DOM is already ready
    initGiftCardLanguage();
  }
})();
